module.exports = __webpack_public_path__ + "static/media/profilePic4.e205273e.png";